<template>
  <component id="app" :is="layout">
    <router-view :layout.sync="layout" />
  </component>
</template>

<script>
import Default from "./layouts/Default";
import Onboarding from "./layouts/Onboarding";
import Training from "./layouts/Training";
import loadSource from '@/mixins/load-source'

// import { getItemStorage } from "@/plugins/utils";

export default {
  mixins: [loadSource],
  computed: {
    layout() {
      return this.$store.getters.layout;
    }
  },
  components: {
    default: Default,
    onboarding: Onboarding,
    "online-training": Training
  }, 
  mounted() {
    this.loadJS('https://www.google-analytics.com/analytics.js', { async: true }).then(() => {
      window.ga =
        window.ga ||
        function() {
          (window.ga.q = window.ga.q || []).push(arguments);
        };
      window.ga.l = +new Date();
      window.ga("create", `${process.env.VUE_APP_GOOGLE_ANALYTICS_KEY}`, "auto");
      window.ga("send", "pageview");
    })

    // this.loadJS(`https://www.googletagmanager.com/gtag/js?id=${process.env.VUE_APP_GOOGLE_ANALYTICS_KEY}`, {async: true}).then(() => {
    //    window.dataLayer = window.dataLayer || [];
    //   function gtag(){window.dataLayer.push(arguments);}
    //   gtag('js', new Date());

    //   gtag('config', `${process.env.VUE_APP_GOOGLE_ANALYTICS_KEY}`);
    // });
  }
};
</script>

<style lang="scss">
@import "~bulma";
@import "~bulma-steps/dist/css/bulma-steps.min.css";
@import "~buefy/dist/buefy.css";
$primary: #ff8200;

#app {
  font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  // margin-top: 60px;
  // background-color: #e5e5e5;
}
.has-text-warning {
  color: #ff8200 !important;
}
.is-primary {
  background-color: #ff8200 !important;
}

.b-radio.radio input[type="radio"] + .check.is-warning:before {
  background: #ff8200;
}
.b-radio.radio input[type="radio"]:checked + .check.is-warning {
  border-color: #ff8200;
}
.b-radio.radio:hover input[type="radio"]:not(:disabled) + .check.is-warning {
  border-color: #ff8200;
}

.b-checkbox.checkbox input[type="checkbox"]:checked + .check {
  background: #ff8200
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:white' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat center center;
  border-color: #ff8200;
}
.b-checkbox.checkbox:hover input[type="checkbox"]:not(:disabled) + .check {
  border-color: #ff8200;
}
.b-checkbox.checkbox input[type="checkbox"]:focus + .check {
  box-shadow: none;
}
.column,
.columns {
  margin-bottom: 0 !important;
}

.navbar {
  background-color: whitesmoke;

  .navbar-item img {
    max-height: 2.75rem;
  }

  .navbar-menu.is-active {
    background-color: whitesmoke;
  }
}
</style>
